import { observer, inject } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { Card } from 'antd';
import { BlackPointStore } from '../../store/BlackPointStore';
import { TLCode } from '../../common/enums';
import glamorous from 'glamorous';
import { PharmacyStore, BlackPointTypeStore, BlackPointStatusStore } from '../../store';
import * as glamor from 'glamor';
import { RouteComponentProps } from 'react-router-dom';
import BlackPointForm from './BlackPointForm';
import { BlackPointStatusCode } from '../../common/enums/BlackPointStatusCode';

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const CardStyle = glamor.css({
  height: '100%',
  '& .ant-card-body': {
    height: '100%',
  },
});

interface BlackPointPageProps extends RouteComponentProps<{ blackPointId: string }> {
  BlackPointStore?: Instance<typeof BlackPointStore>;
  BlackPointTypeStore?: Instance<typeof BlackPointTypeStore>;
  BlackPointStatusStore?: Instance<typeof BlackPointStatusStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
}

interface BlackPointPageState {
  isLoading: boolean;
}

@inject('BlackPointStore')
@inject('BlackPointTypeStore')
@inject('BlackPointStatusStore')
@inject('PharmacyStore')
@observer
class BlackPointPage extends React.Component<BlackPointPageProps, BlackPointPageState> {
  state = {
    isLoading: false,
  };

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    const { BlackPointStore, PharmacyStore } = this.props;
    const BlackPointIdParam = this.props.match.params.blackPointId;
    const BlackPointId = Number(BlackPointIdParam);
    this._isMounted && this.setState({ isLoading: true });
    await PharmacyStore!.loadList();
    if (BlackPointId > 0) {
      await BlackPointStore!.loadElement(BlackPointId);
    }
    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  save = async (data: any) => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.BlackPointStore!.saveBlackPoint(data);
    this._isMounted && this.setState({ isLoading: false });
  };

  render() {
    const { BlackPointStore, PharmacyStore, BlackPointTypeStore, BlackPointStatusStore } = this.props;
    const blackPointIdParam = this.props.match.params.blackPointId;
    const blackPointId = Number(blackPointIdParam);
    const blackPoint = BlackPointStore!.getByIdOrNew(blackPointId);
    const blackPointTypeList = BlackPointTypeStore!.dataList;
    if (blackPoint && blackPoint.blackPointId === 0) {
      const blackPointStatusList = BlackPointStatusStore!.dataList;
      const status = blackPointStatusList.find((elem) => {
        return elem.code === BlackPointStatusCode.SUBMITTED;
      });
      if (status) {
        blackPoint.blackPointStatusId = status!.blackPointStatusId;
      }
    }

    const pharmacyList = PharmacyStore!.dataList;

    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.BLACKPOINT_Title}>
        <Container>
          <Card className={CardStyle.toString()}>
            <BlackPointForm
              blackPoint={blackPoint}
              pharmacyList={pharmacyList}
              blackPointTypeList={blackPointTypeList}
              save={this.save}
              getTypeById={BlackPointTypeStore!.getById}
            />
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default BlackPointPage;
